import React, { useEffect, useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import routes from '../routeNames';
import { t } from '../i18n';
import Logo from '../logo.svg';
import { useUi } from '../context/UiContext';
import { languages } from '../i18n';
import { FiMoon, FiSun, FiMonitor, FiEye, FiMenu, FiX } from 'react-icons/fi';
import { trackEvent, trackPageview } from '../analytics';

export default function Layout(props) {
  const { children } = props;
  const { theme, setTheme, contrast, setContrast, lang, setLang } = useUi();
  const nextTheme = () => {
    const order = ['dark', 'light', 'system'];
    const idx = order.indexOf(theme);
    const next = order[(idx + 1) % order.length];
    setTheme(next);
    trackEvent('toggle_theme', { theme: next });
  };
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    trackPageview(location.pathname, document.title);
  }, [location.pathname]);
  return (
    <div className="app-shell">
      <nav className="nav">
      <div className="nav-gradient" />
        <div className="container nav-inner">
          <Link to={routes.home} className="brand">
            <img src={Logo} alt="logo" />
            <span>St-Louis.io</span>
          </Link>
          <button className="nav-toggle" aria-label="Menu" onClick={() => setOpen(!open)}>
            {open ? <FiX /> : <FiMenu />}
          </button>
          <div className={`nav-links ${open ? 'open' : ''}`}>
            <NavLink end to={routes.home} className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>{t(lang, 'nav.home')}</NavLink>
            <NavLink to={routes.who} className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>{t(lang, 'nav.who')}</NavLink>
            <NavLink to={routes.projects} className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>{t(lang, 'nav.projects')}</NavLink>
            <NavLink to={routes.community} className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>{t(lang, 'nav.community')}</NavLink>
            <NavLink to={routes.contact} className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>{t(lang, 'nav.contact')}</NavLink>
            <div className="nav-controls-gap" />
            <button title={`Theme: ${theme}`} onClick={nextTheme} className="icon-btn">
              {theme === 'dark' ? <FiMoon /> : theme === 'light' ? <FiSun /> : <FiMonitor />}
            </button>
            <button aria-label={`High contrast: ${contrast === 'high' ? 'on' : 'off'}`} title={`High contrast: ${contrast === 'high' ? 'on' : 'off'}`} onClick={() => { const next = contrast === 'high' ? 'normal' : 'high'; setContrast(next); trackEvent('toggle_contrast', { contrast: next }); }} className="icon-btn">
              <FiEye />
            </button>
            <select aria-label="Language" className="select-btn" value={lang} onChange={e => { setLang(e.target.value); trackEvent('change_language', { lang: e.target.value }); }}>
              {languages.map(l => <option key={l.code} value={l.code}>{l.label}</option>)}
            </select>
          </div>
        </div>
        <div className="nav-gradient" />
      </nav>
      <main>
        <div className="container">
          {children}
        </div>
      </main>
      <div className="footer">
      <div className="nav-gradient" />
        <div className="container">© {new Date().getFullYear()} St-Louis.io — Crafted with modern web technologies <span style={{ opacity: 0.6, marginLeft: 8 }} title={`branch ${process.env.REACT_APP_BRANCH || 'local'} • build ${process.env.REACT_APP_BUILD_NUMBER || 'dev'}`}>v {process.env.REACT_APP_PKG_VERSION || '0.0.0'} build +{process.env.REACT_APP_BUILD_NUMBER || 'dev'}</span></div>
      </div><div className="nav-gradient" />
    </div>
  );
}


